window.assetsImages = require.context('./../images', true);

// import external dependencies
import 'jquery';
window.$ = window.jQuery = require('jquery');
require('jquery-mask-plugin');

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';

import lazyLoadingBackgroundImage from './miscellaneous/lazyLoadingBackgroundImage';

// scripts routes
import aboutUs from './routes/about';
import common from './routes/common';
import home from './routes/home';
import passwordReset from './routes/passwordReset';
import templateDashboard from './routes/templateDashboard.js';
import templateSchool from './routes/templateSchool.js';
import templateTopics from './routes/templateTopics';
import pageCustomerUpdateSubscription from './routes/pages/customerUpdateSubscription';

/** Populate Router instance with DOM routes */
const routes = new Router({
    aboutUs,
    common,
    home,
    passwordReset,
    templateDashboard,
    templateSchool,
    templateTopics,
    pageCustomerUpdateSubscription,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

lazyLoadingBackgroundImage();



// WEBPACK FOOTER //
// ./scripts/main.js